import { BlockActions } from '@modules/Nzo.CMS/Frontend/apps/web/cmsPage/blocks/shared/blockActions'
import { BlockProps, BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockHeader } from '../shared/blockHeader'

const TextBlockBase = (props: BlockProps<'TextBlock'> & { mini?: boolean }) => {
  const { id, text, mini } = props

  const { inView, ref } = useInView({ threshold: 0.1 })

  return (
    <section id={id} ref={ref} className={cn('block block--text ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props}  />

        <div className="block__content">
          <div className={cn('block__text text--styled', mini && 'text--sm')} dangerouslySetInnerHTML={{ __html: text }} />
          <BlockActions {...props} datalayerCategory={mini ? 'text_mini_block' : 'text_block'} />
        </div>
      </div>
    </section>
  )
}

export const TextBlock: BlocksView['TextBlock'] = (props) => <TextBlockBase {...props} />

export const TextMiniBlock: BlocksView['TextMiniBlock'] = (props) => <TextBlockBase {...props} mini />
